export interface Category {
  id: string;
  name: string;
  desc: string;
  count: string;
  icon: string;
  tone: string;
}

export const categories: Category[] = [
  { id: "person", name: "人物档案", desc: "明星、主播、KOL 话题人物完整档案与成长时间线整理", count: "320+", icon: "ri-user-star-line", tone: "primary" },
  { id: "variety", name: "综艺现场", desc: "真人秀名场面、舞台名场面与高能片段专题整理", count: "186+", icon: "ri-tv-2-line", tone: "accent" },
  { id: "drama", name: "影视热剧", desc: "热播剧、电影口碑争议与角色设定讨论合集", count: "240+", icon: "ri-film-line", tone: "secondary" },
  { id: "sports", name: "体坛风云", desc: "赛事高光、运动员话题与体育圈热议盘点", count: "95+", icon: "ri-medal-line", tone: "primary" },
  { id: "finance", name: "财经圈层", desc: "商业事件、企业故事与行业八卦式深度解读", count: "120+", icon: "ri-line-chart-line", tone: "accent" },
  { id: "society", name: "社会议题", desc: "社会热点事件脉络梳理与多方观点索引", count: "150+", icon: "ri-earth-line", tone: "secondary" },
  { id: "tech", name: "科技前沿", desc: "大厂动态、产品争议与行业人物话题专题", count: "88+", icon: "ri-cpu-line", tone: "primary" },
  { id: "music", name: "音乐现场", desc: "颁奖礼、舞台事故与乐坛热议事件合集", count: "104+", icon: "ri-mic-line", tone: "accent" },
];

export interface TrendingItem {
  id: number;
  rank: number;
  title: string;
  heat: string;
  category: string;
  tag: string;
  desc: string;
  updated: string;
}

export const trending: TrendingItem[] = [
  { id: 1, rank: 1, title: "年度舞台名场面盘点：这 10 个高光瞬间承包了整个热搜", heat: "1280 万", category: "综艺现场", tag: "连续剧瓜", desc: "从导师抢人到现场翻车，我们把今年讨论度最高的舞台片段按时间线完整归档，方便一键回顾全过程。", updated: "刚刚" },
  { id: 2, rank: 2, title: "爆款热剧口碑争议始末：评分从 8.2 到 6.5 发生了什么", heat: "1150 万", category: "影视热剧", tag: "长瓜预警", desc: "一部剧如何在两周内从全网吹爆走向口碑崩盘，我们把剧情争议、主创回应与观众声量变化整理成完整时间线。", updated: "12 分钟前" },
  { id: 3, rank: 3, title: "选手翻红现象观察：从查无此人到霸榜热搜只用了三个月", heat: "980 万", category: "人物档案", tag: "人物线", desc: "当一位过气选手凭借一档综艺重新走进大众视野，他的每一步都值得被记录，本文梳理了完整的人物弧光。", updated: "26 分钟前" },
  { id: 4, rank: 4, title: "颁奖礼名场面合集：高光、尴尬与名垂青史的瞬间", heat: "860 万", category: "音乐现场", tag: "多图预警", desc: "红毯造型、获奖感言与镜头捕捉到的微表情，一起拼出颁奖季最值得回味的那些名场面。", updated: "1 小时前" },
  { id: 5, rank: 5, title: "品牌联名翻车复盘：一次营销如何演变成全网群嘲", heat: "740 万", category: "财经圈层", tag: "复盘向", desc: "从官宣文案到主播回应，我们还原了这场联名风波的关键节点，并整理了各方观点供你参考。", updated: "2 小时前" },
  { id: 6, rank: 6, title: "节目停播风波追踪：导演、投资方与观众的三方博弈", heat: "690 万", category: "综艺现场", tag: "追踪中", desc: "一档高热度节目为何突然停播？我们整理了官方说明、内幕传闻与网友反应的时间线，帮你判断真假。", updated: "3 小时前" },
  { id: 7, rank: 7, title: "体育圈大满贯时刻复盘：那场载入史册的比赛究竟赢在哪", heat: "610 万", category: "体坛风云", tag: "数据向", desc: "用技术统计与慢动作拆解，复盘那场让无数人熬夜见证的逆转比赛，讲清楚每一个关键分。", updated: "5 小时前" },
  { id: 8, rank: 8, title: "年度塌房预警清单：那些让粉丝连夜脱粉的事件", heat: "570 万", category: "人物档案", tag: "避雷向", desc: "不跟风、不造谣，我们把本年度讨论度高且证据相对完整的事件做了脉络化整理，供理性吃瓜参考。", updated: "6 小时前" },
  { id: 9, rank: 9, title: "直播间翻车名场面：主播的一句话为何引爆全网", heat: "520 万", category: "社会议题", tag: "热点速览", desc: "从一句口误到持续发酵的舆论风暴，我们梳理了事件传播链条与各方最新回应。", updated: "8 小时前" },
  { id: 10, rank: 10, title: "大厂竞业风波解读：高管离职与商业机密之争的来龙去脉", heat: "480 万", category: "科技前沿", tag: "深度向", desc: "用最通俗的语言讲清这场商业纠纷的起因、争点与可能走向，看完不再一脸懵。", updated: "10 小时前" },
];

export const hotTags = ["长瓜预警", "人物线", "复盘向", "连续剧瓜", "避雷向", "追踪中", "数据向", "名场面", "深度解读", "理性吃瓜"];

export const categoryFilters = ["全部", "综艺现场", "影视热剧", "人物档案", "音乐现场", "体坛风云", "财经圈层", "社会议题", "科技前沿"];

export interface Topic {
  id: number;
  badge: string;
  title: string;
  intro: string;
  count: string;
  views: string;
  image: string;
  color: string;
}

export const topics: Topic[] = [
  { id: 1, badge: "连续剧瓜 · 已更新至第 3 季", title: "《年度综艺风云录》", intro: "把全年讨论度最高的综艺争议、名场面与幕后故事串成一部追更式长剧，越看越上头。", count: "已归档 46 期", views: "320 万次浏览", image: "https://readdy.ai/api/search-image?query=%20%20warm%20editorial%20backstage%20scene%20of%20a%20colorful%20variety%20show%20set%20with%20neon%20stage%20lights%2C%20retro%20tv%20cameras%2C%20confetti%20in%20air%2C%20coral%20and%20golden%20tones%2C%20cinematic%20soft%20light%2C%20stylized%20illustration%20texture&width=800&height=500&seq=chigua-topic-01&orientation=landscape", color: "bg-accent-500" },
  { id: 2, badge: "专题企划 · 主编力荐", title: "《流量与口碑的博弈》", intro: "一档节目、一部剧如何平衡热度与口碑？用十个典型案例拆解内容行业最真实的生存法则。", count: "已归档 28 期", views: "210 万次浏览", image: "https://readdy.ai/api/search-image?query=%20%20abstract%20warm%20editorial%20collage%20of%20media%20rating%20charts%2C%20comment%20bubbles%20and%20film%20reels%2C%20terracotta%20and%20cream%20palette%2C%20soft%20shadows%2C%20stylized%20minimal%20illustration&width=800&height=500&seq=chigua-topic-02&orientation=landscape", color: "bg-secondary-500" },
  { id: 3, badge: "人物专题 · 深度档案", title: "《顶流是如何炼成的》", intro: "从籍籍无名到万人空巷，复盘顶级明星每一步关键选择背后的舆论逻辑与团队运作。", count: "已归档 32 期", views: "285 万次浏览", image: "https://readdy.ai/api/search-image?query=%20%20warm%20editorial%20portrait%20of%20a%20silhouetted%20performer%20on%20stage%20with%20spotlight%20and%20crowd%20silhouettes%2C%20golden%20and%20coral%20tones%2C%20dramatic%20cinematic%20lighting%2C%20stylized%20illustration&width=800&height=500&seq=chigua-topic-03&orientation=landscape", color: "bg-primary-500" },
  { id: 4, badge: "深度复盘 · 冷静吃瓜", title: "《一场舆论风暴的解剖》", intro: "谣言如何生成？真相如何澄清？用传播学视角还原一场热点从发酵到降温的完整周期。", count: "已归档 19 期", views: "168 万次浏览", image: "https://readdy.ai/api/search-image?query=%20%20stylized%20editorial%20image%20of%20newspaper%20clippings%20and%20magnifying%20glass%20over%20warm%20desk%2C%20tea%20cup%2C%20soft%20amber%20lighting%2C%20cream%20background%2C%20minimal%20flat%20illustration%20style&width=800&height=500&seq=chigua-topic-04&orientation=landscape", color: "bg-accent-500" },
  { id: 5, badge: "行业观察 · 商业向", title: "《台前与幕后》", intro: "走进经纪公司、节目组与品牌方，看清台前光鲜背后的商业逻辑与行业潜规则。", count: "已归档 24 期", views: "142 万次浏览", image: "https://readdy.ai/api/search-image?query=%20%20warm%20editorial%20scene%20of%20a%20modern%20creative%20studio%20meeting%20room%20with%20charts%20and%20storyboards%2C%20laptops%2C%20golden%20hour%20light%2C%20terracotta%20accents%2C%20cinematic%20stylized%20illustration&width=800&height=500&seq=chigua-topic-05&orientation=landscape", color: "bg-secondary-500" },
  { id: 6, badge: "年度盘点 · 完结篇", title: "《年度吃瓜大事件全回顾》", intro: "年终巨献！把一整年的出圈事件按领域汇总成一份完整年历，收藏这篇就够用了。", count: "已归档 50 期", views: "398 万次浏览", image: "https://readdy.ai/api/search-image?query=%20%20warm%20editorial%20collage%20of%20a%20large%20wall%20calendar%20with%20event%20pins%20and%20polaroid%20photos%2C%20strings%20and%20clips%2C%20golden%20and%20coral%20tones%2C%20cozy%20stylized%20illustration&width=800&height=500&seq=chigua-topic-06&orientation=landscape", color: "bg-primary-500" },
];

export interface MapField {
  name: string;
  desc: string;
  icon: string;
  children: string[];
}

export const mapFields: MapField[] = [
  { name: "人物圈层", desc: "按人检索完整档案", icon: "ri-user-heart-line", children: ["顶流", "综艺咖", "主播", "主持人", "运动员", "创作者"] },
  { name: "事件圈层", desc: "按事追踪来龙去脉", icon: "ri-focus-3-line", children: ["争议", "翻车", "反转", "官宣", "塌房", "和解"] },
  { name: "领域圈层", desc: "按领域分类浏览", icon: "ri-gallery-view-2", children: ["娱乐", "体育", "财经", "科技", "社会", "音乐"] },
  { name: "时间圈层", desc: "按时间倒序回溯", icon: "ri-time-line", children: ["今日", "本周", "本月", "年度", "历年", "经典"] },
];

export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  { q: "吃瓜百科是什么？", a: "吃瓜百科是一个面向大众的热门事件专题目录与合集导航站。我们把散落在各处的热门人物、事件和领域话题，按清晰的分类与知识图谱整理成索引，让你从一个入口就能高效定位和了解想要追的内容，省去东奔西跑的麻烦。" },
  { q: "内容是按什么规则分类的？", a: "我们采用「人物档案、事件追踪、领域圈层、时间回溯」四维组织方式。你可以先按自己熟悉的方式进入：想了解某个人的可以进人物圈层，想追某个事件的可以看事件脉络，习惯按行业看的则直接浏览领域分类，互不冲突。" },
  { q: "追「连续剧瓜」是什么意思？", a: "这是我们对跨多天、多轮更新事件的爱称。这类事件往往会不断反转、多次冲上热搜，我们为它们建立时间线专题，像追剧一样持续更新，方便你随时回看最新进展，不会因为错过几天而看不懂。" },
  { q: "文章里的信息可信吗？", a: "吃瓜百科坚持「不造谣、不传谣、追进展要冷静」的原则。我们把事件按「已证实、待核实、网传」分级标注，并尽可能注明信息来源与更新时间，帮助你在信息过载的环境里做出自己的判断。" },
  { q: "会收费吗？如何保持更新？", a: "目前全站内容免费浏览，方便大家随时进来「补课」。我们每天由人工结合热门指数筛选话题并维护索引，重点专题持续跟进更新，保证这份目录始终贴近当下的讨论热点。" },
];

export interface Stat {
  num: string;
  label: string;
}

export const stats: Stat[] = [
  { num: "1300+", label: "已归档专题" },
  { num: "26 万+", label: "全网累计阅读" },
  { num: "90%", label: "信息标注清晰度" },
  { num: "4 大", label: "知识圈层索引" },
];